module.exports = __webpack_public_path__ + "static/media/ring_to_king.66931e20.png";